// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2saDj","row":"Node_row__2B-RG","label":"Node_label__5tv1Z","footer":"Node_footer__2CT4J"};